export default {
  oldGlobal: true, // for 1/23 release, we want to resemble old DL, even if Data is very poor!
  preventClicks: false,
  debug: false
};
